import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ConstructionRoundedIcon from "@mui/icons-material/ConstructionRounded";
import { theme } from "../../theme";

interface ComingSoonProps {
  label?: string;
}

const ComingSoon: React.FC<ComingSoonProps> = ({ label = "This section" }) => {
  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: "12px",
        boxShadow:
          "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        minHeight: "420px",
        p: 4,
      }}
    >
      <ConstructionRoundedIcon sx={{ fontSize: 64, color: theme.palette.primary.main, mb: 2 }} />
      <Typography variant="h3" fontWeight={800} color="text.secondary" sx={{ mb: 1 }}>
        Coming Soon
      </Typography>
      <Typography variant="h6" color="text.secondary">
        {label} is currently unavailable and will be back soon.
      </Typography>
    </Box>
  );
};

export default ComingSoon;
